import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const IndemnityMissionService = {
    async getAllIndemnityMissions(){
        try{
        const result = await axios.get(`${apiUrl}/MissionIndemnity/`);
        if (result) {
            return result.data;
          }
        } catch (error)
        {
        if (error.response) {
            return error.response.data;
          }
        }
    },
        async filterMission(formData){
            try{
                const result = await axios.post(
            `${apiUrl}/MissionIndemnity/filterMission`,{
                filterData:formData
            });
                if (result) {
                    return result.data;
                }
            }
            catch(error){
                if(error.response){
                    return error.response.data;
                }
            }
        },
    async getDestinaitonsIndemnity(agendaId){
        try{
        const result = await axios.get(`${apiUrl}/MissionIndemnity/detailsAgendaIndemnity/`+agendaId);

        if (result) {
            return result.data;
          }

        } catch (error)
        {
        if (error.response) {
        return error.response.data;
      }
        }
    }


}

export default IndemnityMissionService;